import React from 'react';
import BlackListLinkContext, { NavigationLink } from './BlackListLinkContext';

function getCurrent(): NavigationLink[] {
  const current = localStorage.getItem('blackListLinks');
  if (!current) return [];
  return JSON.parse(current);
}

export default function BlackListLinkContextProvider(props: { children: React.ReactNode }) {
  const { children } = props;
  const [links, setLinks] = React.useState(getCurrent());
  const value = React.useMemo(() => ({
    links,
    addLink: (link: NavigationLink) => {
      const newLinks = [...links, link];
      localStorage.setItem('blackListLinks', JSON.stringify(newLinks));
      setLinks(newLinks);
    },
    removeLink: (link: NavigationLink) => {
      const newLinks = links.filter((item) => item !== link);
      localStorage.setItem('blackListLinks', JSON.stringify(newLinks));
      setLinks(newLinks);
    },
  }), [links]);

  return (
    <BlackListLinkContext.Provider value={value}>
      {children}
    </BlackListLinkContext.Provider>
  );
}
